import { render, staticRenderFns } from "./dettaglioSportEdit.vue?vue&type=template&id=49674c31"
import script from "./dettaglioSportEdit.vue?vue&type=script&lang=js"
export * from "./dettaglioSportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports